import { AddItem, TextButton, Thumbnail } from '@wix/design-system';
import { useFilePicker } from 'hooks/useFilePicker';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectImageStep.scss';
import { urlUtils } from 'utils/url';
import { ReplaceSmall } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import { useMockupStore } from 'stores/mockupStore';

type Props = {
  isSelected: boolean;
  onSelect: () => void;
};

export const SelectImageStepUpload: FC<Props> = ({ isSelected, onSelect }) => {
  const { t } = useTranslation();

  const localFile = useAppStore((state) => state.localFile);
  const setLocalFile = useAppStore((state) => state.setLocalFile);
  const safeFileUrl = localFile && urlUtils.createSafeFileUrl(localFile);

  const isLoading = useMockupStore((state) => state.isLoading);

  const { openFilePicker } = useFilePicker({
    onFilePicked: (file) => {
      if (file) {
        setLocalFile(file);
        onSelect();
      }
    },
  });

  return (
    <div className={styles.selectImageStepUpload}>
      <div className={styles.selectImageStepUploadMedia}>
        {safeFileUrl ? (
          <Thumbnail onClick={onSelect} selected={isSelected} disabled={isLoading && !isSelected}>
            <img src={safeFileUrl} alt={safeFileUrl} className={styles.selectImageStepUploadMediaImage} />
          </Thumbnail>
        ) : (
          <AddItem onClick={openFilePicker} size="small" disabled={isLoading}>
            {t('select-image-step.upload.add-item.caption')}
          </AddItem>
        )}
      </div>
      {safeFileUrl && (
        <TextButton size="small" prefixIcon={<ReplaceSmall />} onClick={openFilePicker} disabled={isLoading}>
          {t('select-image-step.upload.replace-image')}
        </TextButton>
      )}
    </div>
  );
};
